import { Backdrop, Box, Typography, CircularProgress } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';

export const MaintenanceOverlay = () => {
  return (
    <Backdrop open sx={{ zIndex: 9999, backgroundColor: '#1f2833', flexDirection: 'column', gap: 3 }}>
      <BuildIcon sx={{ fontSize: 56, color: '#ff9900' }} />
      <Typography
        variant="h5"
        sx={{ color: '#ff9900', fontFamily: 'Courier New', fontWeight: 'bold', textAlign: 'center' }}
      >
        Scheduled Maintenance
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: '#c5c6c7', fontFamily: 'Courier New', textAlign: 'center', maxWidth: 360, px: 2 }}
      >
        ScanSeqR is temporarily offline for maintenance.
        <br />
        We'll be back shortly.
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 1 }}>
        <CircularProgress size={16} sx={{ color: '#ff9900' }} />
        <Typography variant="caption" sx={{ color: '#c5c6c7', fontFamily: 'Courier New' }}>
          Checking for recovery every 30 seconds…
        </Typography>
      </Box>
    </Backdrop>
  );
};
